import React, { lazy } from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Clara Roche',
    role: 'Instructrice Mat Pilates, Paris',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80',
    text: "J'enseigne à Paris et le temps de préparation était mon plus grand stress. Avec Pilates Prêt, j'ai retrouvé ma vie sociale. Les séquences sont fluides et mes élèves adorent la structure Core Intense."
  }, {
    name: 'Julien Morel',
    role: 'Studio Pilates Propriétaire, Nice',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80',
    text: "Le Lexique Français-Anglais m'a sauvé ! J'ai pu commencer à donner des cours aux expatriés à Nice. Le pack 6 en 1 vaut largement son prix, c'est une véritable bible."
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-204">
      <div className="max-w-5xl mx-auto" data-id="element-205">
        <div className="text-center mb-12" data-id="element-206">
          <div className="bg-pilates-lavender/25 text-pilates-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-207">
            Ce qu'en disent vos collègues
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-208">
            Témoignages de professionnels{' '}
            <span className="italic text-pilates-sage-dark" data-id="element-209">en France</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-210">
          {testimonials.map((t, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 shadow-sm border border-pilates-sage/15 flex flex-col" data-id="element-211">
              <div className="flex text-pilates-rose mb-4" data-id="element-212">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-213" />)}
              </div>
              <p className="text-pilates-slate leading-relaxed mb-6 italic flex-1 text-base" data-id="element-214">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-pilates-sage/20" data-id="element-215">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover" loading="lazy" decoding="async" width="48" height="48" data-id="element-216" />
                <div data-id="element-217">
                  <p className="font-display font-semibold text-pilates-dark text-base" data-id="element-218">
                    {t.name}
                  </p>
                  <p className="text-pilates-slate text-xs" data-id="element-219">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}